import React, { useEffect } from "react";
import PlanDetail from "../../../../components/templates/Plans/PlanDetail/PlanDetail";
import PlanDetailSEO from "../../../../components/molecules/seo/Plans/PlanDetailSEO";
import { useRouter } from "next/router";

function PlanDetailPage(props) {
    const router = useRouter();

    // redirect to slug path
    useEffect(() => {
        console.log(router);
        if (router.query.plan_pk != props.plan.slug) {
            const prevQuery = router.query;
            prevQuery.plan_pk && delete prevQuery.plan_pk;

            router.replace({
                pathname: `/plans/plan/${props.plan.slug}`,
                query: { ...prevQuery },
            });
        }
    }, [router]);

    return (
        <>
            <PlanDetailSEO plan={props.plan} />
            <PlanDetail {...props.plan} />
        </>
    );
}

const cacheFile = "temp-plan-data.json";
export async function getStaticPaths() {
    let {
        fetchBuildingPlans,
        getPlanPaths,
    } = require("../../../../utils/fetchBuildData");
    const plans = await fetchBuildingPlans(
        process.env.NODE_ENV === "development"
    );

    return {
        paths: getPlanPaths(plans, cacheFile),
        fallback: false,
    };
}

// This also gets called at build time
export async function getStaticProps({ params }) {
    const { getPlan } = require("../../../../utils/fetchBuildData");
    const plan = await getPlan(params.plan_pk, cacheFile);

    return {
        props: {
            plan,
        },
        // revalidate: 60 * 60 * 24 * 1, // 1 days
    };
}

export default PlanDetailPage;
